import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import styles from './DangerConfirmationModal.scss';

const DangerConfirmationModal = ({ onClose, onApprove, data, staticTexts }) => {
    const handleClickApprove = () => {
        onApprove(data);
        onClose();
    };

    return (
        <div
            className={styles.modalHolder}
            data-testid='danger-confirmation-modal'
        >
            <div className={styles.contentHolder}>
                <div className={styles.title}>
                    {staticTexts.title}
                </div>
                <div className={styles.subTitle}>
                    {staticTexts.subTitle}
                </div>
                <div className={styles.buttonsHolder}>
                    <Button
                        onClick={handleClickApprove}
                        className={styles.approveButton}
                        data-testid='danger-confirmation-modal__approve-button'
                        aria-label={staticTexts.approveButton}
                    >
                        {staticTexts.approveButton}
                    </Button>
                    <Button
                        onClick={onClose}
                        className={styles.cancelButton}
                        data-testid='danger-confirmation-modal__cancel-button'
                        aria-label={staticTexts.cancelButton}
                    >
                        {staticTexts.cancelButton}
                    </Button>
                </div>
            </div>
        </div>
    );
};

DangerConfirmationModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onApprove: PropTypes.func.isRequired,
    staticTexts: PropTypes.shape({
        title: PropTypes.string,
        subTitle: PropTypes.string,
        cancelButton: PropTypes.string,
        approveButton: PropTypes.string
    }).isRequired,
    data: PropTypes.object
};

DangerConfirmationModal.defaultProps = {
    data: {}
};

export default DangerConfirmationModal;
